import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { IFornecedores, Fornecedores } from '../../../../models/fornecedores.model';
import { Subscription } from 'rxjs';
import { UsersService } from '../../../../models/usuarios.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';


@Component({
    selector: 'dados-loja',
    templateUrl: './dados-loja.component.html',
    styleUrls: ['./dados-loja.component.scss']
})
export class DadosLojaComponent implements OnInit {
    item: any;
    fornClass: Fornecedores;
    event: Subscription;
    form: FormGroup;
    constructor(private db: AngularFirestore,
        private users: UsersService,
        private router: Router) {

        this.fornClass = new Fornecedores(this.db);
        this.event = this.fornClass.changedEvent.subscribe(
            r => {
                this.item = r[0];
            }
        );
        if (this.users.usuario.fornecedor > 0) {
            this.fornClass.snapshot(r => {
                return r.where("codigo", "==", Number(this.users.usuario.fornecedor));
            })
        }
        this.form = new FormGroup({
            nome: new FormControl(),
            cep: new FormControl(),
            endereco: new FormControl(),
            email: new FormControl(),
            estado: new FormControl(),
            cidade: new FormControl(),
            telefone: new FormControl(),
            lojaFechada: new FormControl(),

        })
    }

    ngOnInit(): void {
    }

   post(value){
       //console.log(value, this.item);
       if (this.item.id!=null){
           this.item.freteMinimo = Number(this.item.freteMinimo);
           this.fornClass.update(this.item.id,this.item);
       }
       this.voltar();
   }
   cancel(){
       this.voltar();
   }
   voltar(){
      this.router.navigate(['/']);
   }

}
